module.exports = __webpack_public_path__ + "static/img/8.e7e1348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/8.png
// module id = Bd1v
// module chunks = 1